<mat-dialog-content class="relative overflow-visible" style="overflow: visible !important;">
  <button
    mat-icon-button
    class="!absolute !top-2 !right-2 z-50 bg-white"
    style="position: absolute; top: 8px; right: 8px;"
    (click)="dialogRef.close()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div class="overflow-y-auto max-h-[90vh] pb-8" style="scrollbar-width: none; -ms-overflow-style: none;">
    <div *ngIf="loading" class="flex items-center justify-center h-64">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div *ngIf="!loading" class="flex flex-col items-center w-full h-full">
      <!-- DOCU-1137: hidden-in-export label -->
      <div *ngIf="currentImage.hidden" class="lightbox-hidden-label">
        <mat-icon>visibility_off</mat-icon>
        <span>{{ 'AUDIT.PHOTO_LAYOUT.HIDDEN' | translate }}</span>
      </div>
      <!-- DOCU-1143: annotated copy label -->
      <div *ngIf="isAnnotatedCopy" class="lightbox-hidden-label">
        <mat-icon>draw</mat-icon>
        <span>{{ 'AUDIT.ANNOTATE.COPY_LABEL' | translate }}</span>
      </div>
      <!-- Navigation and image -->
      <div class="flex items-center justify-center w-full" style="height: 70vh;">
        <!-- Previous Button -->
        <button
          type="button"
          class="mx-2 p-0 bg-transparent border-none outline-none disabled:opacity-0"
          [disabled]="!hasPrevious"
          (click)="previousImage()"
          [attr.aria-label]="'IMAGE.PREVIOUS' | translate"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>

        <!-- Image Container -->
        <div 
          #imageContainer
          class="image-container"
          [class.zoomed]="isZoomed"
          (click)="onImageClick($event)"
          (mousedown)="onMouseDown($event)"
          (mousemove)="onMouseMove($event)"
          (mouseup)="onMouseUp()"
          (mouseleave)="onMouseUp()"
        >
          <img
            #imageElement
            [src]="currentImage.image"
            alt="Selected image"
            draggable="false"
          />
        </div>

        <!-- Next Button -->
        <button
          type="button"
          class="mx-2 p-0 bg-transparent border-none outline-none disabled:opacity-0"
          [disabled]="!hasNext"
          (click)="nextImage()"
          [attr.aria-label]="'IMAGE.NEXT' | translate"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <!-- DOCU-1137: group comment -->
      <div *ngIf="currentImage.caption" class="lightbox-caption">{{ currentImage.caption }}</div>

      <div *ngIf="allImages.length > 1" class="flex gap-2 mt-4 overflow-x-auto">
        <img
          *ngFor="let img of allImages; let idx = index"
          [src]="img.thumb || img.image"
          (click)="currentIndex = idx"
          [class.border-blue-500]="currentIndex === idx"
          class="h-16 w-16 object-cover rounded cursor-pointer border-2"
          [style.borderColor]="currentIndex === idx ? '#3b82f6' : '#e5e7eb'"
          [style.opacity]="img.hidden ? 0.35 : 1"
          alt="Thumbnail"
        />
      </div>

      <!-- Image Counter -->
      <div *ngIf="allImages.length > 1" class="mt-2 text-sm text-gray-600">
        {{ currentIndex + 1 }} / {{ allImages.length }}
      </div>

      <!-- DOCU-1143: annotate -->
      <div *ngIf="canAnnotate" class="flex w-full mt-4 gap-4 justify-center">
        <button mat-flat-button color="primary" type="button" (click)="annotate()">
          <mat-icon>draw</mat-icon>
          {{ (isAnnotatedCopy ? 'AUDIT.ANNOTATE.REDO' : 'AUDIT.ANNOTATE.BUTTON') | translate }}
        </button>
        <button *ngIf="isAnnotatedCopy" mat-stroked-button type="button" [disabled]="discarding"
                (click)="discardAnnotation()">
          <mat-icon>undo</mat-icon>
          {{ 'AUDIT.ANNOTATE.DISCARD' | translate }}
        </button>
      </div>

      <!-- Actions -->
      <div *ngIf="allowDelete" class="flex w-full mt-4 gap-4 justify-center">
        <button
          mat-flat-button
          color="warn"
          class="min-w-[170px] flex items-center justify-center gap-2 py-3 rounded-lg font-bold text-lg"
          (click)="deleteImage()"
        >
          <mat-icon>delete</mat-icon>
          <span class="whitespace-nowrap">{{ 'AUDIT.DELETE_IMAGE' | translate }}</span>
        </button>
        
      </div>
    </div>
  </div>
</mat-dialog-content>
